import React from 'react';

function parseInline(text: string): React.ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g);
  return (
    <>
      {parts.map((part, i) => {
        if (part.startsWith('**') && part.endsWith('**')) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (link) {
          return <a key={i} href={link[2]} target="_blank" rel="noopener noreferrer">{link[1]}</a>;
        }
        return part;
      })}
    </>
  );
}

export default function MarkdownRenderer({ content }: { content: string }) {
  const lines = content.split('\n');
  const elements: React.ReactNode[] = [];
  let listItems: React.ReactNode[] = [];
  let key = 0;

  const flushList = () => {
    if (listItems.length > 0) {
      elements.push(<ul key={key++} className="md-ul">{listItems}</ul>);
      listItems = [];
    }
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.startsWith('#### ')) {
      flushList();
      elements.push(<h4 key={key++} className="md-h4">{parseInline(line.slice(5))}</h4>);
    } else if (line.startsWith('### ')) {
      flushList();
      elements.push(<h3 key={key++} className="md-h3">{parseInline(line.slice(4))}</h3>);
    } else if (line.startsWith('## ')) {
      flushList();
      elements.push(<h2 key={key++} className="md-h2">{parseInline(line.slice(3))}</h2>);
    } else if (line === '---') {
      flushList();
      elements.push(<hr key={key++} className="md-hr" />);
    } else if (line.startsWith('> ')) {
      flushList();
      elements.push(<blockquote key={key++} className="md-blockquote">{parseInline(line.slice(2))}</blockquote>);
    } else if (line.startsWith('- ') || line.startsWith('* ')) {
      listItems.push(<li key={key++} className="md-li">{parseInline(line.slice(2))}</li>);
    } else if (line.trim() === '') {
      flushList();
    } else {
      flushList();
      elements.push(<p key={key++} className="md-p">{parseInline(line)}</p>);
    }
  }
  flushList();

  return <div className="md-body">{elements}</div>;
}
